module.exports = __webpack_public_path__ + "1_0_65/img/Eiffel Tower.f119ab51.jpg";